export const STATUS_COLORIZE = {
  CREATE: '#c9ffc9',
  DELETE: '#fce3e3',
};

export const USER_ROLE = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  EDIT: 'EDIT',
  READ: 'READ',
};

export const LOG_EVENT_TYPE = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export const USER_TYPE = {
  MANAGER: 'MANAGER',
  DEVELOPER: 'DEVELOPER',
  WORKER: 'WORKER',
};

export const LOGS_ACTION_TYPE = {
  GET_USERS: 'GET_USERS',
  BUY_CARD: 'BUY_CARD',
  TRANSFER_CARD: 'TRANSFER_CARD',
  OTHER: 'OTHER',
};

export const LOGS_ACTION_TYPES = [
  { id: LOGS_ACTION_TYPE.GET_USERS, name: LOGS_ACTION_TYPE.GET_USERS },
  { id: LOGS_ACTION_TYPE.BUY_CARD, name: LOGS_ACTION_TYPE.BUY_CARD },
  { id: LOGS_ACTION_TYPE.TRANSFER_CARD, name: LOGS_ACTION_TYPE.TRANSFER_CARD },
  { id: LOGS_ACTION_TYPE.OTHER, name: LOGS_ACTION_TYPE.OTHER },
];

export const USER_ROLES = [
  { id: USER_ROLE.SUPER_ADMIN, name: USER_ROLE.SUPER_ADMIN },
  { id: USER_ROLE.EDIT, name: USER_ROLE.EDIT },
  { id: USER_ROLE.READ, name: USER_ROLE.READ },
];

export const LOG_EVENT_TYPES = [
  {
    id: LOG_EVENT_TYPE.CREATE,
    name: LOG_EVENT_TYPE.CREATE,
    color: STATUS_COLORIZE.CREATE,
  },
  {
    id: LOG_EVENT_TYPE.UPDATE,
    name: LOG_EVENT_TYPE.UPDATE,
    color: STATUS_COLORIZE.CREATE,
  },
  {
    id: LOG_EVENT_TYPE.DELETE,
    name: LOG_EVENT_TYPE.DELETE,
    color: STATUS_COLORIZE.DELETE,
  },
];

export const USER_TYPES = [
  { id: USER_TYPE.MANAGER, name: USER_TYPE.MANAGER },
  { id: USER_TYPE.DEVELOPER, name: USER_TYPE.DEVELOPER },
  { id: USER_TYPE.WORKER, name: USER_TYPE.WORKER },
];

export const TRASACTION_STATUSE = {
  5: 'Created',
  20: 'Confirmed',
  30: 'Approved',
  35: 'Declined',
  45: 'Refund',
};
export const TRASACTION_STATUSES = [
  { id: 5, name: 'Created' },
  { id: 20, name: 'Confirmed' },
  { id: 30, name: 'Approved' },
  { id: 35, name: 'Declined' },
  { id: 45, name: 'Refund' },
];

export const USER_CARD_STATUSE = {
  1: 'Active',
  10: 'Blocked',
  20: 'Expired',
};

export const USER_CARD_STATUSES = [
  { id: 1, name: 'Active' },
  { id: 10, name: 'Blocked' },
  { id: 20, name: 'Expired' },
];
